/**
 * Оценочный лист для проверяющего.
 */
import React from "react";
import {withStyles} from "@material-ui/core/styles";
import TextareaAutosize from 'react-textarea-autosize'

const styles = {
  tableBordered: {
    width: '100%',

    '& tr th': {
      padding: '7px 12px',
      border: '1px solid #ddd',
      backgroundColor: '#eee'
    },

    '& tr td': {
      border: '1px solid #ddd',
      padding: '0 12px',
      fontSize: '13px'
    },

    '& tr:last-child td': {
      border: '1px solid #ddd',
      padding: '7px 12px'
    },

    '& tr td input': {
      width: '100%',
      padding: '7px 0',
      border: 'none',
      backgroundColor: '#fafafa'
    },
    '& tr td textarea': {
      width: '100%',
      padding: '7px 0',
      marginTop: '5px',
      border: 'none',
      backgroundColor: '#fafafa'
    }
  },
  deleteIcon: {
    fill: 'red',
    fontSize: '12px'
  },
  button: {
    padding: '3px',
    minWidth: '0',
    minHeight: '0',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff'
    },
    cursor: 'pointer'
  },
  buttonAdd: {
    padding: '7px 12px',
    minWidth: '0',
    minHeight: '0',
    backgroundColor: '#fff',
    '&:hover': {
      backgroundColor: '#fff'
    },
    cursor: 'pointer'
  },
  label: {
    color: 'rgba(0, 0, 0, 0.54)',
  }
}

const AnswersTableExpert = ({classes, data, totalBalls, factBalls, onCellChange, question, showAdditionText}) => {
  return (
    <section>
      <table className={classes.tableBordered}>
        <thead>
        <tr>
          <th style={{textAlign: 'left'}}>№ задания</th>
          <th style={{textAlign: 'left'}}>Маркировочная позиция</th>
          <th style={{textAlign: 'left', width: '50px'}}>Макс. балл</th>
          <th style={{textAlign: 'left', width: '50px'}}>Факт. балл</th>
          <th style={{textAlign: 'left'}}>Комментарии</th>
          <th style={{textAlign: 'left'}}>&nbsp;</th>
          <th style={{textAlign: 'left'}}>&nbsp;</th>
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
          {showAdditionText && (
            <th>&nbsp;</th>
          )}
        </tr>
        </thead>
        <tbody>
        {data.map((row, index) => {
          return (
            <tr key={row.id}>
              <td>{row.number}</td>
              <td>{row.mark}</td>
              <td>{row.maxBalls}</td>
              <td><input type="number" step="0.1" min="0" max={row.maxBalls} value={row.ballExpert ? row.ballExpert.ball : ''} onChange={(event) => onCellChange(question, index, 'ball', event.target.value.replace(',', '.'))} /></td>
              <td>
                <TextareaAutosize onChange={(event) => onCellChange(question, index, 'comment', event.target.value)} value={row.ballExpert ? row.ballExpert.comment : ''}>
                  {row.ballExpert ? row.ballExpert.comment : ''}
                </TextareaAutosize>
              </td>
              <td>{row.correctValues}</td>
              <td>{row.solution}</td>
              {showAdditionText && (
                <td>{row.additionText1}</td>
              )}
              {showAdditionText && (
                <td>{row.additionText2}</td>
              )}
              {showAdditionText && (
                <td>{row.additionText3}</td>
              )}
              {showAdditionText && (
                <td>{row.additionText4}</td>
              )}
            </tr>
          )
        })}
        <tr>
          <td colSpan={2}><b>Итого по подвопросу</b></td>
          <td><b>{totalBalls}</b></td>
          <td><b>{factBalls}</b></td>
          <td colSpan={showAdditionText ? 7 : 3}>&nbsp;</td>
        </tr>
        </tbody>
      </table>
    </section>
  )
}

export default withStyles(styles)(AnswersTableExpert)